import I18n from 'I18n';
import { Typeahead } from 'foundations-components/transitional/components/Typeahead';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { jsx as _jsx } from "react/jsx-runtime";
export default function SnippetPopoverContentResults({
  snippets,
  onSelect,
  setQueryInput,
  setSearched
}) {
  const handleSelect = evt => {
    evt.preventDefault();
    evt.stopPropagation();
    onSelect(evt.target.value);
  };
  const handleSearchChange = evt => {
    evt.preventDefault();
    evt.stopPropagation();
    setSearched(true);
    setQueryInput(evt.target.value);
  };
  const renderResults = () => {
    return snippets.map(snippet => {
      return {
        text: snippet.name,
        help: /*#__PURE__*/_jsx(TruncateString, {
          children: snippet.body
        }),
        value: snippet.html
      };
    });
  };
  return /*#__PURE__*/_jsx(Typeahead, {
    onChange: handleSelect,
    placeholder: I18n.text('RichTextLib.snippet.search'),
    options: renderResults(),
    onSearchChange: handleSearchChange
  });
}